import React, { useMemo } from 'react';

import { Image } from 'js/components/common/Image';

import {
    BOTTOM_LEFT_SASH,
    BOTTOM_RIGHT_SASH,
    SASHES_CLASSES,
    TOP_LEFT_SASH,
    TOP_RIGHT_SASH } from 'js/app/components/main/Games/components/GameTile/components/DetailedTile/constants';
import { clsx } from 'js/app/utils/clsx.util';

import style from './GameSashes.scss';

export const GameSashes = ({ additionalAssets }) => {
    const sashes = useMemo(() => additionalAssets.filter(item =>
        [TOP_LEFT_SASH, TOP_RIGHT_SASH, BOTTOM_LEFT_SASH, BOTTOM_RIGHT_SASH].includes(item.name.trim()) && item.url),
    [additionalAssets]);

    if (!sashes.length) {
        return null;
    }

    return (
        sashes.map((item) => (
            <Image
                data-testid="GameSashes_image"
                key={item.name}
                src={item.url}
                alt={item.name}
                className={clsx(style.sashImg, style[SASHES_CLASSES[item.name]])}
            />
        ))
    );
};
